var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#0A033C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15C16.7956 15 17.5587 14.6839 18.1213 14.1213C18.6839 13.5587 19 12.7956 19 12C19 11.2044 18.6839 10.4413 18.1213 9.87868C17.5587 9.31607 16.7956 9 16 9C15.2044 9 14.4413 9.31607 13.8787 9.87868C13.3161 10.4413 13 11.2044 13 12C13 12.7956 13.3161 13.5587 13.8787 14.1213C14.4413 14.6839 15.2044 15 16 15ZM9 24C9 23.0807 9.18106 22.1705 9.53284 21.3212C9.88463 20.4719 10.4002 19.7003 11.0503 19.0503C11.7003 18.4002 12.4719 17.8846 13.3212 17.5328C14.1705 17.1811 15.0807 17 16 17C16.9193 17 17.8295 17.1811 18.6788 17.5328C19.5281 17.8846 20.2997 18.4002 20.9497 19.0503C21.5998 19.7003 22.1154 20.4719 22.4672 21.3212C22.8189 22.1705 23 23.0807 23 24H9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.b19c344364b7e5bbf91b0c3af8f80982.svg";
export { ForwardRef as ReactComponent };